function initPfFinalCtaProxies() {
	document
		.querySelectorAll(".pf-final-cta__buy-buttons-wrap")
		.forEach((wrap) => {
			const proxy = wrap.querySelector(".pf-final-cta__button-proxy");
			const realButton = wrap.querySelector(".add-to-cart-btn");

			if (!proxy || !realButton) return;

			const updateProxyPosition = () => {
				const btnRect = realButton.getBoundingClientRect();
				const wrapRect = wrap.getBoundingClientRect();
				const radius = window.getComputedStyle(realButton).borderRadius;

				proxy.style.left = `${btnRect.left - wrapRect.left}px`;
				proxy.style.top = `${btnRect.top - wrapRect.top}px`;
				proxy.style.width = `${btnRect.width}px`;
				proxy.style.height = `${btnRect.height}px`;
				proxy.style.borderRadius = radius;
			};

			updateProxyPosition();

			const onResize = () => updateProxyPosition();
			window.addEventListener("resize", onResize);

			const onScroll = () => {
				window.requestAnimationFrame(updateProxyPosition);
			};
			window.addEventListener("scroll", onScroll, { passive: true });

			const setHoverState = (enabled) => {
				if (!realButton.classList) return;
				if (enabled) realButton.classList.add("pf-final-cta__button-hover");
				else realButton.classList.remove("pf-final-cta__button-hover");
			};

			proxy.addEventListener("mouseenter", () => setHoverState(true));
			proxy.addEventListener("mouseleave", () => setHoverState(false));

			proxy.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();

				if (realButton.disabled) return;

				// Ensure hover animation runs even if user clicks quickly.
				setHoverState(true);
				window.setTimeout(() => setHoverState(false), 180);

				const essentialButton =
					document.querySelector(
						'[data-essential-cart-element="add-to-cart-button"]'
					) ||
					document.querySelector(".essential-preorder-extra-add-to-cart-button");

				if (essentialButton) {
					essentialButton.click();
					return;
				}

				// Backup: submit the Shopify product form inside the CTA section.
				const productForm = wrap.querySelector("form[data-product-form]");
				if (productForm?.requestSubmit) productForm.requestSubmit();
				else productForm?.submit?.();
			});
		});
}

document.addEventListener("DOMContentLoaded", initPfFinalCtaProxies);
document.addEventListener("shopify:section:load", initPfFinalCtaProxies);
